export const filterProjects = (type, repos, setRepos) => {
  const filteredRepos = [...repos];

  if (type === "javascript") {
    filteredRepos.forEach((repo) => {
      if (repo.language !== "JavaScript") {
        repo.hidden = true;
      } else {
        repo.hidden = false;
      }
    });
  } else if (type === "css") {
    filteredRepos.forEach((repo) => {
      if (repo.language !== "CSS") {
        repo.hidden = true;
      } else {
        repo.hidden = false;
      }
    });
  } else if (type === "vue") {
    filteredRepos.forEach((repo) => {
      if (repo.language !== "Vue") {
        repo.hidden = true;
      } else {
        repo.hidden = false;
      }
    });
  } else if (type === "scss") {
    filteredRepos.forEach((repo) => {
      if (repo.language !== "SCSS") {
        repo.hidden = true;
      } else {
        repo.hidden = false;
      }
    });
  } else {
    filteredRepos.forEach((repo) => {
      repo.hidden = false;
    });
  }

  setRepos(filteredRepos);
};
